import Repository from "./Repository";

export default {
    login(email, password){
        return Repository.post('login', {email: email, password: password});
    },
    signup(email, password){
        return Repository.post('signup', {email: email, password: password});
    },
    passwordReset(email){
        return Repository.post('password_reset_link', {email: email});
    },
    confirmReset(params){
        return Repository.post('confirm_reset', params);
    }
};